import React from "react";
import { AiOutlineGift } from "react-icons/ai";
import { MdOutlineLocalOffer } from "react-icons/md";
import { FiPackage, FiShoppingBag } from "react-icons/fi";
import { BiMessageSquareDetail } from "react-icons/bi";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import matrixAvatar from "../../../assets/church-login/matrix-avatar.png";

const DashboardHeader = () => {
  const { seller } = useSelector((state) => state.seller);

  return (
    <div className="shop-dashboard-header-container">
      <div>
        <Link
          to={`/dashboard/${seller?.handle}`}
          className="main-header-component-brand-link"
          aria-label="Matrix Gateway Community business dashboard"
        >
          <span className="main-header-component-brand-lockup">
            <img
              src={matrixAvatar}
              className="main-header-component-brand-avatar"
              alt="Matrix avatar"
            />
            <span className="main-header-component-brand-text">
              <span className="main-header-component-brand-title" aria-label="MATRIX">
                {"MATRIX".split("").map((letter, index) => (
                  <span key={`${letter}-${index}`} aria-hidden="true">{letter}</span>
                ))}
              </span>
              <span className="main-header-component-brand-subtitle">Gateway Community</span>
            </span>
          </span>
        </Link>
      </div>

      {/* Navigation Icons */}
      <div className="shop-dashboard-header-links">
        <div className="shop-dashboard-header-icons">
          <Link to="/dashboard-coupons" className="shop-dashboard-header-icon-link">
            <AiOutlineGift className="shop-dashboard-header-icon" />
          </Link>
          <Link to="/dashboard-events" className="shop-dashboard-header-icon-link">
            <MdOutlineLocalOffer className="shop-dashboard-header-icon" />
          </Link>
          <Link to="/dashboard-products" className="shop-dashboard-header-icon-link">
            <FiShoppingBag className="shop-dashboard-header-icon" />
          </Link>
          <Link to="/dashboard-orders" className="shop-dashboard-header-icon-link">
            <FiPackage className="shop-dashboard-header-icon" />
          </Link>
          <Link to="/dashboard-messages" className="shop-dashboard-header-icon-link">
            <BiMessageSquareDetail className="shop-dashboard-header-icon" />
          </Link>

          {/* Seller Avatar */}
          <Link to={`/shop/preview/${seller?.handle}`}>
            <img
              src={`${seller?.avatar?.url}`}
              alt=""
              className="shop-dashboard-header-avatar"
            />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default DashboardHeader;


